import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FilterUrlService } from '../../services/filter-url.service';
import { LoadService } from '../../services/load.service';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
})
export class PaginatorComponent implements OnInit {
  @Input() links:any;
  @Input() meta:any;
  @Input() urlconditions:any;
  @Output() updateData = new EventEmitter <any> ();
  @Output() updateData2 = new EventEmitter <any> ();
  filter:string;
  public alert:string;
  public isopen:boolean;

  constructor( private _globalService:GlobalService, private url_service:FilterUrlService, private _loaddata:LoadService ) {
    this.alert = '';
    this.isopen = false;
  }

  ngOnInit() {
    this.url_service.filters.subscribe(new_filter => this.filter = new_filter );
  }

  navigate(url:string){
    console.log("URL ANTES: ", url);
    this._loaddata.loadChange(40);
    this.alert = 'Cargando Resultados';
    this.isopen = true;
    if(this.filter.length > 0){
      url += "&"+this.filter.slice(1);
      //console.log("URL MAS FILTRO: ",url);
    }

    this._globalService.navigate(url).subscribe(
      (response:any) => {
        //console.log("Respuesta desde el Paginate: ", response);
        this.updateData.emit(response.data);

        /*este se emite para la paginacion de stock*/
        this.updateData2.emit(response);
        /*este se emite para la paginacion de stock*/

        this.links = response.links;
        if(this.links.first != null && this.urlconditions != undefined){
          this.links.first = this.links.first+''+this.urlconditions;
        }
        if(this.links.last != null && this.urlconditions != undefined){
          this.links.last = this.links.last+''+this.urlconditions;
        }
        if(this.links.next != null && this.urlconditions != undefined){
          this.links.next = this.links.next+''+this.urlconditions;
        }
        if(this.links.prev != null && this.urlconditions != undefined){
          this.links.prev = this.links.prev+''+this.urlconditions;
        }
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = 'Resultados Cargados';
        this.isopen = true;
        this.onClosedAutomatic();
      },
      (error) => {
        if(error.statusText != ""){
          this.updateData.emit("Error al cargar listado.");
          //this.showError(error.statusText);
        }
        else{
          this.updateData.emit("Error al cargar listado.");
        }
      }
    );
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
    },3000);
  }

  onClosed(){
    this.isopen=false;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/shared/paginator.component.ts